var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_25398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8167 13.934L10.5511 9.66838C11.3774 8.64778 11.8749 7.35091 11.8749 5.93843C11.8749 2.66471 9.21114 0.000976562 5.93742 0.000976562C2.6637 0.000976562 0 2.66468 0 5.9384C0 9.21212 2.66373 11.8759 5.93745 11.8759C7.34993 11.8759 8.6468 11.3784 9.66741 10.5521L13.933 14.8177C14.0549 14.9396 14.2149 15.0008 14.3749 15.0008C14.5349 15.0008 14.6949 14.9396 14.8168 14.8177C15.0611 14.5733 15.0611 14.1783 14.8167 13.934ZM5.93745 10.6259C3.35247 10.6259 1.25 8.52339 1.25 5.9384C1.25 3.35342 3.35247 1.25095 5.93745 1.25095C8.52244 1.25095 10.6249 3.35342 10.6249 5.9384C10.6249 8.52339 8.52241 10.6259 5.93745 10.6259Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06944 5.41944H6.24657V3.59657C6.24657 3.36817 6.06141 3.18301 5.83301 3.18301C5.6046 3.18301 5.41944 3.36817 5.41944 3.59657V5.41944H3.59657C3.36817 5.41944 3.18301 5.6046 3.18301 5.83301C3.18301 6.06141 3.36817 6.24657 3.59657 6.24657H5.41944V8.06944C5.41944 8.29785 5.6046 8.48301 5.83301 8.48301C6.06141 8.48301 6.24657 8.29785 6.24657 8.06944V6.24657H8.06944C8.29785 6.24657 8.48301 6.06141 8.48301 5.83301C8.48301 5.6046 8.29785 5.41944 8.06944 5.41944Z",
    fill: "#8F8F8F",
    stroke: "#8F8F8F",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_25398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlus);
export default __webpack_public_path__ + "static/media/search-plus.50b6c926.svg";
export { ForwardRef as ReactComponent };